module.exports = __webpack_public_path__ + "img/4-3.bcc9879d.png";